import axios from 'axios';
import { useEffect, useState } from 'react';
import { DataType } from '../types/SharedTypes';

export const useData = (url: string) => {
	const [data, setData] = useState<DataType | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	useEffect(() => {
		if (!url) return;

		const controller = new AbortController();

		const fetchData = async () => {
			try {
				setIsLoading(true);
				setError(null);

				const response = await axios.get(url, { signal: controller.signal });

				setData(response.data);
			} catch (err) {
				if (axios.isCancel(err)) return;

				setError(err instanceof Error ? err.message : 'An error occurred');
			} finally {
				setIsLoading(false);
			}
		};

		fetchData();

		return () => {
			controller.abort();
		};
	}, [url]);

	return { data, error, isLoadingAppData: isLoading };
};
